import React, { useEffect, useState } from "react";
import { getCodeFromUrl } from "../../../../utils/helper";
import { api_strapi } from "../../../../utils/interface";
import "./index.scss";

const ProductBanner = () => {
  const [img, setImg] = useState("");
  const agCode = getCodeFromUrl();

   useEffect(() => {
      const banner = async () => {
        if (agCode) {
          const response = await api_strapi.get(
            `/homes?filters[slug][$eq]=${agCode}&populate=banner.productBanner`
          );
  
          if (response && response.status === 200) {
            const bannerImg =
              response?.data?.data?.[0]?.attributes?.banner?.productBanner?.data
                ?.attributes?.url;
            setImg(bannerImg);
          }
        }
      };
      banner();
    }, [agCode]);

  return (
    <div className="product-banner-container">
      <img
        src={img}
        alt="Product Banner"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
        }}
      />
    </div>
  );
};

export default ProductBanner;
